import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import paginationComponent from '../../../../components/pagination/pagination.component';
import { formats as FORMATS, staticUrls } from '../../../../config/constants';
import taskTodoModel from '../../../../models/task-management/to-do-management.model';
import ViewBase from '../../../view-base.view';

export default function ToDoTaskDetailsView() {

    ViewBase.call(this);

    var inputDataModel = {
        filter: "",
        taskName: "",
        isMandatory: "",
        radioOption: "",
        data: [],
        fromDate: "",
        toDate: "",
        taskList: "",
        siteList: "",
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
    };

    let onClose = () => { };

    let parentInputParams;
    let _getTaskDetailList = () => {
        this.showLoading();
        inputDataModel.fromDate = moment(parentInputParams.scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
        inputDataModel.toDate = moment(parentInputParams.scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
        inputDataModel.taskList = parentInputParams.taskMstId;
        inputDataModel.siteList = "";
        inputDataModel.filter = "Task^" + inputDataModel.radioOption + "^";

        return taskTodoModel.getTaskDetail(inputDataModel)
            .then((result) => {
                inputDataModel.data = result.data;
                inputDataModel.totalCount = result.total;
                inputDataModel.pageIndex = result.pageIndex;
                inputDataModel.pageSize = result.pageSize;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => { this.hideLoading() });
    }

    let _getData = () => {
        _getTaskDetailList();
    }

    let _initControls = () => {
        _getData();
    }

    let _downloadExcel = () => {
        this.showLoading();
        inputDataModel.fromDate = moment(parentInputParams.scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
        inputDataModel.toDate = moment(parentInputParams.scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat);
        inputDataModel.taskList = parentInputParams.taskMstId;
        inputDataModel.siteList = "";
        inputDataModel.filter = "Task^" + inputDataModel.radioOption + "^";
        let fileName = uuidv4();

        return taskTodoModel.downloadExcelTask(inputDataModel, fileName)
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => { this.hideLoading() });
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _getData();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _getData();
    }

    let _cancel = () => {
        onClose();
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.onClose) {
                onClose = vnode.attrs.onClose;
            }
            if (vnode.attrs.parentEntity) {
                parentInputParams = vnode.attrs.parentEntity;
            }
            _initControls();
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.card.mb-3.mt-2',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.col-12',
                                        m('h5', parentInputParams.taskName)
                                    ),
                                ),
                                m('.row',
                                    m('.col-12',
                                        m('h5', parentInputParams.mandatoryFlag == "Y" ? this.getText("LT00000115", "Mandatory") : this.getText("LT00000131", "Optional"))
                                    )
                                ),
                                m('.row',
                                    m('.col-md-2',
                                        m('.form-check.form-check-inline',
                                            m('input.form-check-input[type="radio"][id="radioOption_all"]',
                                                {
                                                    checked: inputDataModel.radioOption == "",
                                                    onclick: (e) => {
                                                        inputDataModel.radioOption = "";
                                                        inputDataModel.pageIndex = 1;
                                                        _getData();
                                                    }
                                                }
                                            ),
                                            m('label.form-check-label[for="radioOption_all"]', this.getText("LT00000143", "All"))
                                        )
                                    ),
                                    m('.col-md-2',
                                        m('.form-check.form-check-inline',
                                            m('input.form-check-input[type="radio"][id="radioOption_notComplete"]',
                                                {
                                                    checked: inputDataModel.radioOption == "001",
                                                    onclick: (e) => {
                                                        inputDataModel.radioOption = "001";
                                                        inputDataModel.pageIndex = 1;
                                                        _getData();
                                                    }
                                                }
                                            ),
                                            m('label.form-check-label[for="radioOption_notComplete"]', this.getText("LT00000130", "Not Complete"))
                                        )
                                    ),
                                    m('.col-md-2',
                                        m('.form-check.form-check-inline',
                                            m('input.form-check-input[type="radio"][id="radioOption_complete"]',
                                                {
                                                    checked: inputDataModel.radioOption == "002",
                                                    onclick: (e) => {
                                                        inputDataModel.radioOption = "002";
                                                        inputDataModel.pageIndex = 1;
                                                        _getData();
                                                    }
                                                }
                                            ),
                                            m('label.form-check-label[for="radioOption_complete"]', this.getText("LT00000129", "Complete"))
                                        )
                                    ),
                                )
                            )
                        ),
                        m('.card',
                            m('.card-body.pt-0',
                                m('.row',
                                    m(".col-md-12.p-0",
                                        m('.row',
                                            m('.col-12.d-flex.justify-content-end.mt-2.mb-2',
                                                m('.p-2',
                                                    m('a.btn.btn-primary',
                                                        {
                                                            class: inputDataModel.data?.length > 0 ? '' : 'disabled',
                                                            onclick: _downloadExcel
                                                        },
                                                        m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download")
                                                    )
                                                )
                                            ),
                                            m(".col-12",
                                                m(".table-responsive",
                                                    m("table.table",
                                                        m("thead.thead-bggrey",
                                                            m("tr.align-middle",
                                                                m("th"),
                                                                m("th", { "scope": "col" }, this.getText("LT00000050", "User Name")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000144", "Site Name")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000145", "Completion Time")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000015", "Status"))
                                                            )
                                                        ),
                                                        m("tbody",
                                                            inputDataModel.data.length == 0 &&
                                                            m("tr.align-middle",
                                                                m("td.text-center", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                                                            ),
                                                            inputDataModel.data.map(gc => [
                                                                m("tr",
                                                                    m("td", gc.userPhoto == "" && m('img.userImg-circle[src="' + staticUrls.emptyUserImage + '"]'),
                                                                        gc.userPhoto != "" && m('img.userImg-circle[src="' + gc.userPhoto + '"]')
                                                                    ),
                                                                    m("td", gc.userName),
                                                                    m("td", gc.siteName),
                                                                    m("td", gc.toDoTime),
                                                                    m("td.center", gc.toDoStatus == 'Not Complete' && m('.badge.rounded-pill.grey-bg-status', gc.toDoStatus),
                                                                        gc.toDoStatus == 'Completed' && m('.badge.rounded-pill.green-bg-status', gc.toDoStatus)
                                                                    )
                                                                )
                                                            ]),
                                                        )
                                                    )
                                                ),
                                                inputDataModel.data?.length > 0 &&
                                                m(".px-3",
                                                    m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            m('.card-footer',
                                m('.col-md-12 .gap-2 .d-flex .justify-content-center',
                                    m("button.btn.btn-white[type='button']", { onclick: _cancel },
                                        this.getText("LT00000021", "Close")
                                    )
                                )
                            )
                        )
                    ),
                ),
                this.getBaseViews()
            ]
        }
    }
}
